// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"75":"8e01b997","421":"3d656596","488":"205d83ae","520":"ca763e04","638":"7b51e514","705":"6ba85205","770":"7817d9b2","843":"0cf13b57"}[chunkId] + ".chunk.js";
};